import { gql } from '@apollo/client';
import eventBidFragment from './eventBidFragment';

const REMOVE_BIDDING_ON_EVENT = gql`
  mutation RemoveBiddingOnEvent($eventId: Int!) {
    removeBiddingOnEvent(eventId: $eventId) {
      ...EventBidFields
    }
  }
  ${eventBidFragment}
`;

export default REMOVE_BIDDING_ON_EVENT;
